import View from './view'
import PropertyLister from '../controller'
import {imagesToSvg} from '../../../../utils'
import events from '../../../../event-emitter'

export default class PropertyList extends PropertyLister {

    constructor(finder) {
        super(finder)
        this.view = new View(this)

        this.title = 'Alla lediga bostäder: '

        this.listControlsRoot = document.createElement('section')
        this.propertyTabsRoot = document.createElement('section')

        this.listControlsRoot.className = 'list-controls-root'
        this.propertyTabsRoot.className = 'property-tabs-root'

        let urlParams = new URLSearchParams(window.location.search)
        urlParams && urlParams.get('tab') ? this.setActiveTab('projekts') : this.setActiveTab()
    }

    clearPropertyTabs() {
        $(this.propertyTabsRoot).empty()
        return this
    }

    clearListControls() {
        $(this.listControlsRoot).empty()
        return this
    }

    fillListControls() {
        // this.listControlsRoot.appendChild(this.view.listControls())
        return this
    }

    fillPropertyTabs(data = this.props) {
        this.setActiveTab(this.activeTab)
        if (!data || ((!data.projekts && !data.objekts))) {
            return this
        }
        this.propertyTabsRoot.appendChild(this.view.propertyTabs(data.projekts, data.objekts, data.areas))
        if (this.objektsPagination.moreButton) {
            this.propertyTabsRoot.appendChild(this.objektsPagination.moreButton)
        }
        events.emit('PropertyList::fillPropertyTabs')
        return this
    }

    convertImagesToSVG() {
        imagesToSvg($(this.propertyTabsRoot).find('img.replace-with-svg'))
        return this
    }

    manage(data) {
        // console.log(data)
        this.reset()
        this.props.objekts = data.objekts
        this.props.projekts = data.projekts
        this.props.areas = data.areas
        this.view.initObjektsPagination()
        return this
    }

    render() {
        this
            .clearListControls()
            .clearPropertyTabs()
            .sortProps()
            .fillTitle()
            .fillListControls()
            .fillPropertyTabs()
            .convertImagesToSVG()

        return [this.titleRoot, this.listControlsRoot, this.propertyTabsRoot]
    }

    updateProps() {
        this
            .clearListControls()
            .clearPropertyTabs()
            .sortProps()
            .fillListControls()
            .fillPropertyTabs()
            .convertImagesToSVG()

        return this;
    }
}
